export const profileList = () => {
	const removeFromProfileList = <T extends { id: number }>(
		list: { category: number; data: T[] }[],
		item: T,
		category: number
	) => {
		// Find the category object
		const entry = list.find((e) => e.category === category)
		if (!entry) return

		// Remove the item from data
		entry.data = entry.data.filter((i) => i.id !== item.id)

		// Optionally remove the category object if data is empty
		if (entry.data.length === 0) {
			const index = list.indexOf(entry)
			if (index > -1) list.splice(index, 1)
		}
	}

	const addToProfileList = <T extends { id: number }>(
		list: { category: number; data: T[] }[],
		item: T,
		category?: number
	) => {
		let entry = list.find((e) => e.category === category)

		if (entry) {
			if (!entry.data.some((i) => i.id === item.id)) {
				entry.data.push({ ...item }) // prevent reactive proxy issues
			}
		} else {
			list.push({
				category,
				data: [{ ...item }],
			})
		}
	}
	return {
		removeFromProfileList,
		addToProfileList,
	}
}
